export function mixter(a, ...mixins) {
    return mixins.reduce((c, mixin)=>mixin(c)
    , a);
}
